import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-title"]

import { computed } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { LinkBuilder } from '@/core/common';


import components from '@/core/components/resource/columns'

const __default__ = {
	components,
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ResourceTableColumn',
  props: {
    column: {},
    row: {},
    rowLink: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const classList = computed<string[]>(() => {
	const list = props.column.classList;

	if (props.rowLink) {
		list.push('has-link');
	}

	return list;
});

const link = computed<RouteLocationRaw | null>(() => props.rowLink ? props.rowLink(props.row) : null);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("td", {
    "data-title": __props.column.label,
    class: _normalizeClass(classList.value)
  }, [
    (__props.column.component)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.column.component), {
          key: 0,
          column: __props.column,
          row: __props.row
        }, null, 8, ["column", "row"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (link.value)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: link.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.column.render(__props.row)), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(__props.column.render(__props.row)), 1)
              ], 64))
        ], 64))
  ], 10, _hoisted_1))
}
}

})